// extracted by mini-css-extract-plugin
export var categoryIcon = "_dr-5";
export var connectorContainer = "_dr-1";
export var connectorLine = "_dr-0";
export var minHeight0 = "_dr-6";
export var relativeUnitValueSelector = "_dr-2";
export var trifoldSelectorBody = "_dr-4";
export var trifoldSelectorList = "_dr-3";